<template>
	<div id="proxy_container">
		<div class="proxy_banner">
			<div class="banner_title">
				<div class="title">
					<p>B2B代理</p>
					<p>加入代理助力门店智慧收银</p>
				</div>
			</div>
		</div>
		<!-- 中间四大问题板块 -->
		<div class="four_questions">
			<div class="questions_header">
				<p>致力解决以下4大问题</p>
			</div>
			<div class="questions_main">
				<div class="item_container">
					<div class="circle_container">
						<p>慢</p>
					</div>
					<span>收银效率低,结账慢</span>
				</div>
				<div class="item_container">
					<div class="circle_container">
						<p>耗</p>
					</div>
					<span>结算繁琐,耗费人力</span>
				</div>
				<div class="item_container">
					<div class="circle_container">
						<p>乱</p>
					</div>
					<span>数据凌乱,不便整理</span>
				</div>
				<div class="item_container">
					<div class="circle_container">
						<p>少</p>
					</div>
					<span>受地区限制,顾客范围小</span>
				</div>
			</div>
		</div>
		<!-- 服务支持 -->
		<div class="service_support">
			<div class="service_header">
				<p>服务支持</p>
			</div>
			<div class="service_advisory" :style="'margin-top: 45px'">
				<div class="service_left">
					<!-- <img src="" alt=""> -->
					<img src="../assets/B2Biconimg/售前咨询.png" alt />
				</div>
				<div class="service_right">
					<p>售前咨询</p>
					<p>专业客服随时为您答惑,全面了解</p>
				</div>
			</div>
			<div class="service_advisory">
				<div class="service_left">
					<img src="../assets/B2Biconimg/远程维护.png" alt />
					<!-- <img src="" alt=""> -->
				</div>
				<div class="service_right">
					<p>远程维护</p>
					<p>平台稳定,技术团队远程维护系统</p>
				</div>
			</div>
			<div class="service_advisory">
				<div class="service_left">
					<!-- <img src="" alt=""> -->
					<img src="../assets/B2Biconimg/操作指导.png" alt />
				</div>
				<div class="service_right">
					<p>操作指导</p>
					<p>多种指导方式,助力门店快速使用</p>
				</div>
			</div>
			<div class="service_advisory">
				<div class="service_left">
					<img src="../assets/B2Biconimg/后期保障.png" alt />
				</div>
				<div class="service_right">
					<p>后期保障</p>
					<p>团队随时高效解决问题,保障权益</p>
				</div>
			</div>
		</div>
		<!-- 为什么选择我们 -->
		<div class="why_container">
			<div class="why_header">
				<p>为什么选择我们</p>
			</div>
			<div class="four_container">
				<div class="four_main1">
					<div class="main1_top">
						<p>技术优势</p>
					</div>
					<div class="main1_bottom bottom-p">
						<p>由资深工程师,带领的专业团队</p>
					</div>
				</div>
				<div class="four_main2">
					<div class="main2_top">
						<p>数据安全</p>
					</div>
					<div class="main2_bottom bottom-p">
						<p>数据在云端加密存储,保障安全</p>
					</div>
				</div>
				<div class="four_main3">
					<div class="main3_top">
						<p>产品易用</p>
					</div>
					<div class="main3_bottom bottom-p">
						<p>创造简单易用的,新零售平台</p>
					</div>
				</div>
				<div class="four_main4">
					<div class="main4_top">
						<p>专业客服</p>
					</div>
					<div class="main4_bottom bottom-p">
						<p>7*12小时专业,后指导</p>
					</div>
				</div>
			</div>
		</div>
		<!-- 代理流程页面 -->
		<agent></agent>
		<div class="input_container">
			<div class="header_container">
				<p>新零售时代我们携手共赢</p>
			</div>
			<div class="interval"></div>
			<div class="vant_container">
			  <el-form :model="JoinForm" :rules="Join_Rules" ref="JoinForm"  class="demo-ruleForm">
			    <el-form-item label="" prop="fName">
					<div class="label-join"><span>*</span>姓名:</div>
			      <el-input v-model="JoinForm.fName" placeholder="请输入您的姓名"></el-input>
			    </el-form-item>
			    <el-form-item label="" prop="fPhone">
					<div  class="label-join"><span>*</span>联系电话:</div>
			      <el-input v-model="JoinForm.fPhone" placeholder="请输入您的联系方式"></el-input>
			    </el-form-item>
			    <el-form-item  prop="fPost" >
				  <div  class="label-join"><span>*</span>请输入您的申请选项:</div>
			      <div class="el-select-join">
					  <el-select v-model="JoinForm.fPost" placeholder="请输入您的申请选项:">
						<el-option label="自营产品代理" value="自营产品代理"></el-option>
						<el-option label="云服务收银系统及App商城代理" value="云服务收银系统及App商城代理"></el-option><strong></strong>
					  </el-select>
				  </div>
			    </el-form-item>
			    <el-form-item label="" prop="post" style="width: 100%;">
					<div  class="label-join">输入城市:</div>
			      <el-input v-model="JoinForm.fCity" placeholder="请输入您的城市:"></el-input>
			    </el-form-item>
			    <el-form-item label="" prop="personal_profile">
					<div  class="label-join">留言:</div>
			      <el-input type="textarea" v-model="JoinForm.text" placeholder="请输入您的留言"></el-input>
			    </el-form-item>
			    <el-form-item class="btns">
			      <el-button type="warning" @click="growtogether" size="medium" class="mobile-btn">立即申请</el-button>
			    </el-form-item>
			  </el-form>
			</div>
			<div class="news-info">您的信息将被严格保密，信息提交后，客服会近期与您联系，请留意接听电话</div>
		</div>

	</div>
</template>

<script type="text/ecmascript-6">
	import {
	  Message
	} from "element-ui";
	import agent from "../pages/m-agent";
	import {
		Toast
	} from "vant";
	export default {
		components: {
			agent
		},
		created() {
			this.$nextTick(() => {
			  document.body.scrollTop = 0
			  document.documentElement.scrollTop = 0
			})
		},
		data() {
			//   自定义验证规则
			var Name = (rule, value, callback) => {
			  const regNmae = /^[\u4e00-\u9fa5]{2,12}$/;
			  if (regNmae.test(value)) {
			    return callback();
			  } else {
			    callback(new Error("请输入正确的姓名!"));
			  }
			};
			var Post = (rule, value, callback) => {
			  const regNmae = /^[\u4e00-\u9fa5]$/;
			  if (regNmae.test(value)) {
			    return callback();
			  } else {
			    callback(new Error("请选择正确的申请选项!"));
			  }
			};
			var checkMobil = (rule, value, callback) => {
			  // 验证手机号的正则表达式
			  const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
			  if (regMobile.test(value)) {
			    return callback();
			  } else {
			    callback(new Error("请输入正确的手机号!"));
			  }
			};
			return {
				JoinForm: {
				  fName: "", // 姓名
				  fPost: "", // 岗位选择
				  fPhone: "", //电话
				  fCity: "", //城市选择
				  text: "", //个人简介
				  fType: 1
				},
				Join_Rules: {
				  // 姓名验证
				  fName: [{
				      required: true,
				      message: "请输入您的姓名",
				      trigger: "blur"
				    },
				    {
				      validator: Name,
				      trigger: "blur"
				    }
				  ],
				  // 用户密码验证
				  fPhone: [{
				      required: true,
				      message: "请输入您的手机号",
				      trigger: "blur"
				    },
				    {
				      validator: checkMobil,
				      trigger: "blur"
				    }
				  ],
				  // 申请选项验证
				  fPost: [{
				    required: true,
				    message: "请输入您的申请选项",
				    trigger: ["blur", 'change'],

				  },]
				},
				Name: '',
				phone: '',
				options: false,
				options_val:'',
				city:false,
				city_val:'',
				message:'',
				opData: [{
						name: '选项1'
					},
					{
						name: '选项2'
					}
				],

			};
		},
    // mounted (){
    //     this.$router.afterEach((to, from, next) => {
    //         window.scrollTo(0, 0)
    //         document.documentElement.scrollTop = 0
    //     })
    // },
		methods: {
			growtogether() {
			  let {
			    fName,
			    fPhone,
			    fCity,
			    fPost,
			    text,
			    fType
			  } = this.JoinForm;
			  // 前端验证
			  this.$refs.JoinForm.validate(async valid => {
			    if (!valid) {
			      // Message.error("请检查您的信息准确性!");
            Toast.fail('请检查您的信息准确性');

			    } else {
			      const loading = this.$loading({
			        lock: true,
			        text: "正在提交申请,请耐心等待",
			        spinner: "el-icon-loading",
			        background: "rgba(0, 0, 0, 0.7)"
			      });
			      let result = await this.$HTTP.getGrowInfo({
			        fName,
			        fPhone,
			        fCity,
			        fPost,
			        text,
			        fType
			      });
            setTimeout(() => {
              loading.close();
            }, 2000);
			      if (result.status === 200) {
			        loading.close();
			        Toast.success("提交成功!");
			        this.$refs.JoinForm.resetFields()
			        this.JoinForm.fCity = ''
			        this.JoinForm.text = ''
              this.JoinForm.fPost = ''
			      } else {
			        Toast.error("网络开小差了~");
              loading.close();
			      }
			    }
			  });
			},
			validator(val) {
				return /1\d{10}/.test(val);
			},
			// 异步校验函数返回 Promise
			NmaeValidator(val) {
				return new Promise(resolve => {
					Toast.loading("验证中...");

					setTimeout(() => {
						Toast.clear();
						resolve(/\d{6}/.test(val));
					}, 1000);
				});
			},
			onFailed(errorInfo) {
				console.log("failed", errorInfo);
			}
		}
	};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
	@import '../common/stylus/mixins.styl';

	#proxy_container {
		width: 100%;
		height: 100%;

		.proxy_banner {
			width: 100%;
			height: 420px;
			bg-image('../assets/banner');
			background-size: 100% 420px;
			overflow: hidden;

			.banner_title {
				width: 100%;
				height: 100%;
				padding-top: 154px;
				box-sizing: border-box;

				.title {
					margin: 0 auto;
					text-align: center;

					p:nth-child(1) {
						font-size: 56px;
						font-family: Source Han Sans SC;
						font-weight: bold;
						color: rgba(255, 255, 255, 1);
					}

					p:nth-child(2) {
						font-size: 38px;
						font-family: Source Han Sans SC;
						font-weight: bold;
						color: rgba(255, 255, 255, 1);
						margin-top: 30px;
					}
				}
			}
		}

		.four_questions {
			width: 100%;
			height: 855px;
			padding: 57px 125px 82px 123px;
			box-sizing: border-box;
			overflow: hidden;

			.questions_header {
				width: 100%;
				text-align: center;

				p {
					font-size: 36px;
					font-family: Microsoft YaHei;
					font-weight: bold;
					color: rgba(51, 51, 51, 1);
				}
			}

			.questions_main {
				width: 100%;
				height: 598px;
				margin-top: 82px;
				display: flex;
				justify-content: space-between;
				flex-direction: row;
				flex-wrap: wrap;

				.item_container {
					text-align: center;

					.circle_container {
						width: 200px;
						height: 200px;
						border-radius: 50%;
						display: flex;
						justify-content: center;
						align-items: center;
						border: 1px dashed #FFAD60;

						p {
							font-size: 72px;
							font-family: Source Han Sans SC;
							font-weight: 400;
							color: rgba(255, 173, 96, 1);
						}
					}

					span {
						width: 220px;
						height: 20px;
						display: block;
						font-size: 22px;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: rgba(96, 96, 96, 1);
						margin-top: 35px;
					}
				}
			}
		}

		.service_support {
			width: 100%;
			height: 1220px;
			background-color: #FFF7EF;
			padding: 78px 80px 80px 80px;
			box-sizing: border-box;

			.service_header {
				width: 100%;
				text-align: center;

				p {
					font-size: 36px;
					font-family: Microsoft YaHei;
					font-weight: bold;
					color: rgba(51, 51, 51, 1);
				}
			}

			.service_advisory {
				width: 590px;
				height: 207px;
				background-color: #FFFFFF;
				box-shadow: 0px 0px 20px 0px rgba(255, 173, 96, 0.2);
				margin-top: 41px;
				padding: 0 60px;
				box-sizing: border-box;
				display: flex;
				justify-content: space-between;
				align-items: center;

				.service_left {
					width: 92px;
					height: 92px;
					background-color: #ffad60;
					border-radius: 15px;
				}
				.service_left img{
					width: 92px;
					height: 92px;
				}

				.service_right {}

				p:nth-child(1) {
					font-size: 32px;
					font-family: Microsoft YaHei;
					font-weight: bold;
					color: rgba(51, 51, 51, 1);
					line-height: 24px;
				}

				p:nth-child(2) {
					font-size: 20px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: rgba(96, 96, 96, 1);
					margin-top: 17px;
				}
			}
		}

		.why_container {
			width: 100%;
			height: 635px;
			padding: 78px 80px 81px 82px;
			box-sizing: border-box;
			overflow: hidden;

			.why_header {
				width: 100%;

				>p {
					text-align: center;
					font-size: 36px;
					font-family: 'Microsoft YaHei';
					font-weight: bold;
					color: rgba(35, 35, 35, 1);
				}
			}

			.four_container {
				width: 588px;
				height: 420px;
				margin-top: 60px;
				display: flex;
				justify-content: space-between;
				flex-direction: row;
				flex-wrap: wrap;

				.four_main1 {
					width: 274px;
					height: 171px;
					background-image: url('../assets/技术优势背景-移动端.png');
					background-size: 274px 171px;
					background-repeat: no-repeat;

					.main1_top {
						width: 100%;
						height: 70px;
						text-align: center;
						line-height: 70px;

						>p {
							font-size: 36px;
							font-family: 'Source Han Sans SC';
							font-weight: bold;
							color: rgba(255, 255, 255, 1);
						}
					}

					.main1_bottom {
						width: 100%;
						height: 84px;
						padding: 22px 54px 33px 50px;
						box-sizing: border-box;
						text-align: center;

						>p {
							font-size: 22px;
							font-family: Source Han Sans SC;
							font-weight: 400;
							color: rgba(255, 255, 255, 1);
							line-height: 30px;
						}
					}
				}

				.four_main2 {
					width: 274px;
					height: 171px;
					background-image: url('../assets/数据安全背景-移动端.png');
					background-size: 274px 171px;
					background-repeat: no-repeat;

					.main2_top {
						width: 100%;
						height: 70px;
						text-align: center;
						line-height: 70px;

						>p {
							font-size: 36px;
							font-family: 'Source Han Sans SC';
							font-weight: bold;
							color: rgba(255, 255, 255, 1);
						}
					}

					.main2_bottom {
						width: 100%;
						height: 84px;
						padding: 22px 54px 33px 50px;
						box-sizing: border-box;
						text-align: center;

						>p {
							font-size: 22px;
							font-family: Source Han Sans SC;
							font-weight: 400;
							color: rgba(255, 255, 255, 1);
							line-height: 30px;
						}
					}
				}

				.four_main3 {
					width: 274px;
					height: 171px;
					background-image: url('../assets/产品易用背景-移动端.png');
					background-size: 274px 171px;
					background-repeat: no-repeat;

					.main3_top {
						width: 100%;
						height: 87px;
						text-align: center;
						line-height: 87px;

						>p {
							font-size: 36px;
							font-family: 'Source Han Sans SC';
							font-weight: bold;
							color: rgba(255, 255, 255, 1);
						}
					}

					.main3_bottom {
						width: 100%;
						height: 84px;
						padding: 22px 54px 33px 50px;
						box-sizing: border-box;
						text-align: center;

						>p {
							font-size: 22px;
							font-family: Source Han Sans SC;
							font-weight: 400;
							color: rgba(255, 255, 255, 1);
							line-height: 30px;
						}
					}
				}

				.four_main4 {
					width: 274px;
					height: 171px;
					background-image: url('../assets/专业客服背景-移动端.png');
					background-size: 274px 171px;
					background-repeat: no-repeat;

					.main4_top {
						width: 100%;
						height: 87px;
						text-align: center;
						line-height: 87px;

						>p {
							font-size: 36px;
							font-family: 'Source Han Sans SC';
							font-weight: bold;
							color: rgba(255, 255, 255, 1);
						}
					}

					.main4_bottom {
						width: 100%;
						height: 84px;
						padding: 22px 54px 33px 50px;
						box-sizing: border-box;
						text-align: center;

						>p {
							font-size: 22px;
							font-family: Source Han Sans SC;
							font-weight: 400;
							color: rgba(255, 255, 255, 1);
							line-height: 30px;
						}
					}
				}
			}
		}

		.input_container {
			width: 100%;
			height: auto;
			padding-bottom 30px;
			overflow: hidden;
			bg-image('../assets/message');
			background-size: 100% 1012px;
			background-repeat: no-repeat;

			.header_container {
				width: 100%;
				height: 136px;
				position: relative;

				>p {
					width: 100%;
					font-size: 36px;
					font-family: Microsoft YaHei;
					font-weight: bold;
					color: rgba(255, 255, 255, 1);
					position: absolute;
					left: 25%;
					bottom: 0;
				}
			}

			.interval {
				width: 100%;
				height: 47px;
			}

			.vant_container {
				padding: 0 80px;
				box-sizing: border-box;
			}
		}
	}

	.jiange1 {
		width: 100%;
		height: 44px;
	}

	.input-label {
		color #fff;
		margin-bottom: 10px;
	}

	.input-label span {
		color: #FA3A43;
		margin-right: 10px;
	}
	.news-info{
		padding-top 20px;
		width:100%;
		margin 0 auto;
		text-align center;
		height:auto;
		line-height 40px;
		font-size:20px;
		font-family:Microsoft YaHei;
		font-weight:400;
		color:rgba(255,255,255,1);
	}
	.bottom-p{
		margin-top -10px;
	}
	.btns{
	  width 100%;
		padding-top 10px;
		margin 0 auto;
		text-align center
	}
	.el-select-join{
		width 100%
	}
	.label-join{
		width 100%
		height 50px
		color #fff
	}
	.label-join span{
		color red
		margin-right 10px
	}
	.mobile-btn{
	  width :100%;
	  height 48px;
	}
</style>
<style>
	.el-input__inner{
		width: 590px;
		height: 40px;
		line-height: 40px
	}
</style>
